function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 386",
  fill: "none",
  stroke: "#3c00dc",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 450",
  d: "M17.423 4.191a2.507 2.507 0 00-.763.13 2.505 2.505 0 00-3.557-2.01 3.7 3.7 0 00-6.939.911 1.816 1.816 0 00-2.5 1.238 2.5 2.5 0 00-.886-.169 2.53 2.53 0 102.2 3.746 2.5 2.5 0 003.892.844 3.743 3.743 0 006.976-.192 2.525 2.525 0 101.57-4.5z",
  strokeWidth: 0.5
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 451",
  d: "M40.05 14.318a4.5 4.5 0 00-1.369.233 4.493 4.493 0 00-6.379-3.6 6.628 6.628 0 00-12.445 1.635 3.257 3.257 0 00-4.479 2.219 4.489 4.489 0 00-1.59-.3 4.537 4.537 0 103.953 6.707 4.488 4.488 0 006.98 1.514 6.713 6.713 0 0012.511-.344 4.528 4.528 0 102.815-8.068z"
}));

function SvgCloudinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 45.085,
    height: 27.342,
    viewBox: "0 0 45.085 27.342"
  }, props), _ref);
}

export default SvgCloudinline;